// assets/a24-share-links.js
/* Extracted snippet behavior. */
(function () {
  if (window.__smcShareInit) return;
  window.__smcShareInit = true;

  function setFeedback(root, message) {
    var feedback = root.querySelector('.smc-share__feedback');
    if (!feedback) return;
    feedback.textContent = message;
    window.setTimeout(function () {
      if (feedback.textContent === message) {
        feedback.textContent = '';
      }
    }, 2600);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      try {
        var input = document.createElement('input');
        input.value = text;
        input.setAttribute('readonly', 'readonly');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(input);
        if (ok) {
          resolve();
          return;
        }
      } catch (error) {
        reject(error);
        return;
      }

      reject(new Error('copy-failed'));
    });
  }

  document.querySelectorAll('.smc-share').forEach(function (root) {
    var url = root.getAttribute('data-share-url') || window.location.href;
    var title = root.getAttribute('data-share-title') || document.title;
    var openBtn = root.querySelector('.js-smc-share-open');
    var closeBtns = root.querySelectorAll('.js-smc-share-close');
    var modal = root.querySelector('.smc-share-modal');
    var nativeBtn = root.querySelector('.js-smc-share-native');
    var copyBtn = root.querySelector('.js-smc-share-copy');

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    if (openBtn && modal) {
      openBtn.addEventListener('click', openModal);
      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });
    }

    if (nativeBtn && navigator.share) {
      nativeBtn.hidden = false;
      nativeBtn.addEventListener('click', function () {
        navigator.share({
          title: title,
          url: url
        }).catch(function () {
          setFeedback(root, 'Teilen wurde abgebrochen.');
        });
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        copyText(url)
          .then(function () {
            setFeedback(root, 'Link wurde kopiert.');
          })
          .catch(function () {
            setFeedback(root, 'Link konnte nicht kopiert werden.');
          });
      });
    }
  });
})();
